export default __webpack_public_path__ + "static/media/MEI.79cb163a.png";